<template>
  <div class="question-box">
    <div class="question-title">
      <span>{{index+1}}. </span>
      <span class="single-content" v-html="questionContent.content"></span>
      <span class="single-score">({{score}}分)</span>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="question-content-option">
      <div class="question-option" v-for="(item,i) in optionsContent" :key="i">
        <span class="question-option-sort">{{optionMap[i]}}.</span>
        <span class="question-option-content">
          {{item.content}}
        </span>
        <viewer :images="item.file" class="option-img-box">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
    <div class="question-answer" :class="is_right?'is-right':'is-wrong'">
      <span class="it-li">正确答案：{{analysisContent.answer | sortOption}}</span>
      <span class="it-li" v-if="is_right">{{name}}选对了</span>
      <span class="it-li" v-if="!is_right && multipleAnswer">{{name}}错选{{multipleAnswer | sortOption}}</span>
      <span class="it-li" v-if="!is_right && !multipleAnswer">{{name}}未选择答案</span>
      <span class="it-li">+{{student_score}}分</span>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      {{analysisContent.content}}
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'name'],
  data() {
    return {
      multipleAnswer: [],//多选答案
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData: function () {
      this.multipleAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
    },
    isRight: function (index) {
      let answer = this.analysisContent.answer
      let student_answer = this.multipleAnswer
      let cls = ''
      if (!student_answer) {
        return cls
      }
      if (student_answer.indexOf(index) !== -1) {
        if (answer.indexOf(index) !== -1) {
          cls += ' is-right'
        } else {
          cls += ' is-wrong'
        }
      }
      return cls
    },
    //判断多选题答案
    jugeOption: function () {
      let answer = this.analysisContent.answer
      let student_answer = this.multipleAnswer
      if (answer.length !== student_answer.length) {
        return false
      }
      for (let i = 0; i < answer.length; i++) {
        if (student_answer[i] !== answer[i]) {
          return false
        }
      }
      return true
    }
  },
  filters: {
    //排序题答案排序
    sortOption: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        if (i >= value.length - 1) {
          str += arr[value[i]]
        } else {
          str += arr[value[i]] + '->'
        }
      }
      return str
    }
  }
}
</script>

<style scoped="">
</style>